import { forwardRef, type Ref, type SVGProps } from "react";

function SvgBreak(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={176}
      height={120}
      fill="none"
      {...props}
    >
      <g stroke="#0C1C43" strokeLinecap="round" clipPath="url(#break_svg__a)">
        <path d="M72.5 22v8m10-14v14m11-20v20" />
      </g>
      <path
        stroke="url(#break_svg__b)"
        strokeWidth={10}
        d="M56 44.143C56 41.855 57.87 40 60.176 40h45.942c2.306 0 4.176 1.855 4.176 4.143v45.571c0 4.576-3.74 8.286-8.353 8.286H64.353C59.74 98 56 94.29 56 89.714z"
      />
      <path
        stroke="url(#break_svg__c)"
        strokeWidth={10}
        d="M110.294 52.462a4.177 4.177 0 0 1 4.177-4.176c6.919 0 12.529 5.564 12.529 12.428s-5.61 12.429-12.529 12.429a4.177 4.177 0 0 1-4.177-4.177z"
      />
      <defs>
        <linearGradient
          id="break_svg__b"
          x1={91.5}
          x2={91.5}
          y1={40}
          y2={98}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#98CCFB" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
        <linearGradient
          id="break_svg__c"
          x1={91.5}
          x2={91.5}
          y1={40}
          y2={98}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#98CCFB" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
        <clipPath id="break_svg__a">
          <rect width={100} height={100} x={38} y={10} fill="#fff" rx={50} />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgBreak);
export default ForwardRef;
